module.exports = __webpack_public_path__ + "img/icon_zhuanti.72af550c.svg";